module.exports = __webpack_public_path__ + "img/canon-camera.1d0e6cb0.jpg";